export interface PricingPlan {
  id: string;
  name: string;
  price: number;
  tokens: number;
  description: string;
  stripePriceId: string;
  features: string[];
}

export const PRICING_PLANS: Record<string, PricingPlan> = {
  basic: {
    id: 'basic',
    name: 'Basic',
    price: 19.99,
    tokens: 25000,
    description: 'Perfect for getting started',
    stripePriceId: 'price_1RAicWFiHfTOO8Hl6bi1nuxK',
    features: [
      '5 videos',
    ]
  },
  pro: {
    id: 'pro',
    name: 'Pro',
    price: 49.99,
    tokens: 60000,
    description: 'For professionals and teams',
    stripePriceId: 'price_1RAicYFiHfTOO8Hl8CWXBiZG',
    features: [
      '12 Videos',
    ]
  },
  enterprise: {
    id: 'enterprise',
    name: 'Enterprise',
    price: 149.99,
    tokens: 125000,
    description: 'For large organizations',
    stripePriceId: 'price_1RAicZFiHfTOO8HlMixz6XNB',
    features: [
      '25 videos',
    ]
  }
}; 